import { useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const usePropertyTableStatus = (
  listingAlias: ListingAlias,
  options: Partial<RentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status(
    { listingAlias },
    {
      ...options,
      enabled: Boolean(listingAlias) && (options.enabled ?? true),
      meta: {
        tags: ['propertyTableStatus', listingAlias],
        context: {
          api: 'useRentalManagerAccountViewZrmPropertyUnitsWebApiHandler_status',
          details: 'usePropertyTableStatus',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};
